const createSliderBreakpoints = (min, max, step) => {
  const sliderStepsObject = {}
  for (let i = min; i <= max; i++) {
    if (i === min || i === max) sliderStepsObject[i] = i.toString()
    else if (i % step === 0) sliderStepsObject[i] = ''
  }
  return sliderStepsObject
}

const stringToColour = (str) => {
  let hash = 0
  str.split('').forEach((letter) => {
    hash = letter.charCodeAt(0) + ((hash << 5) - hash)
  })
  let colour = '#'
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xFF
    colour += ('00' + value.toString(16)).substr(-2)
  }
  return colour
}

export default {
  createSliderBreakpoints,
  stringToColour
}
